import type { ButtonHTMLAttributes } from 'react'
import { Spinner } from '../spinner/Spinner'
import styles from './Button.module.css'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 'sm' | 'md' | 'lg'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  loading?: boolean
}

const spinnerSize = { sm: 'xs', md: 'xs', lg: 'sm' } as const

export function Button({
  variant = 'primary',
  size = 'md',
  loading,
  className,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const classes = [
    styles.button,
    styles[variant],
    styles[size],
    loading && styles.loading,
    className,
  ].filter(Boolean).join(' ')

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading && <Spinner size={spinnerSize[size]} label="Loading" />}
      <span className={loading ? styles.hiddenContent : styles.content}>{children}</span>
    </button>
  )
}
